
import type Vue from 'vue'
import { defineComponent, getCurrentInstance } from 'vue'
import useExplainKpis from '../../composables/explain/use-explain-kpis'
import { FilterIdEnum } from '../../enums'
import { EpbBadge, EpbLoading, EpbText } from '../shared'
import ExplainDateRange from './explain-date-range.component.vue'

export default defineComponent({
  name: 'ExplainKpiMetrics',
  components: {
    ExplainDateRange,
    EpbBadge,
    EpbText,
    EpbLoading,
  },
  props: {
    query: {
      type: String,
      default: '',
      required: false,
    },
    productId: {
      type: String,
      default: '',
      required: false,
    },
    showDateRange: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  setup(props) {
    const {
      proxy: { $epb },
    } = getCurrentInstance() as {
      proxy: Vue
    }

    const { isAllDataLoaded, kpiConfigs } = useExplainKpis(props.query, props.productId)

    const dateRangeText = $epb.messages.filters.values[FilterIdEnum.DATE].lastSevenDays.label

    return {
      baseClass: 'epb-explain-kpi-metrics',
      isAllDataLoaded,
      kpiConfigs,
      dateRangeText,
    }
  },
})
